import { Input } from "@visiblethread/react-components";
import { func, object, string } from "prop-types";

import classes from "./FieldRow.module.scss";
import RemoveButton from "./RemoveButton";

const DefaultInputField = ({
  formData,
  onDisable,
  onValueChange,
  fieldId,
  label,
  placeholder,
}) => {
  if (formData[fieldId] === null) return null;

  return (
    <div className={classes.formRow}>
      <div className={classes.formRow__field}>
        <label htmlFor={fieldId}>{label}</label>
        <Input
          id={fieldId}
          name={fieldId}
          placeholder={placeholder}
          value={formData[fieldId]}
          onChange={onValueChange(fieldId)}
        />
      </div>
      <div className={classes.formRow__disableButton}>
        <RemoveButton onClick={onDisable(fieldId)} aria-label={`Remove ${label}`} />
      </div>
    </div>
  );
};

DefaultInputField.propTypes = {
  formData: object.isRequired,
  onDisable: func.isRequired,
  onValueChange: func.isRequired,
  fieldId: string.isRequired,
  label: string.isRequired,
  placeholder: string,
};

export default DefaultInputField;
